/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionIssuersCimdClientsListPresets } from "../funcs/userSessionIssuersCimdClientsListPresets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListCimdClientPresetsResult } from "../models/components/listcimdclientpresetsresult.js";
import {
  ListCimdClientPresetsRequest,
  ListCimdClientPresetsSecurity,
} from "../models/operations/listcimdclientpresets.js";
import { unwrapAsync } from "../types/fp.js";
export type CimdClientPresetsQueryData = ListCimdClientPresetsResult;

export function prefetchCimdClientPresets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListCimdClientPresetsRequest | undefined,
  security?: ListCimdClientPresetsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildCimdClientPresetsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildCimdClientPresetsQuery(
  client$: GramCore,
  request?: ListCimdClientPresetsRequest | undefined,
  security?: ListCimdClientPresetsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<CimdClientPresetsQueryData>;
} {
  return {
    queryKey: queryKeyCimdClientPresets({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function cimdClientPresetsQueryFn(
      ctx,
    ): Promise<CimdClientPresetsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionIssuersCimdClientsListPresets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyCimdClientPresets(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "userSessionIssuersCimdClients",
    "listPresets",
    parameters,
  ];
}
